import application_settings from '../applicationSettings';
import Event from './Event';

class RemoveFavoriteProduct extends Event {
    eventName = 'oms_removeFavoriteProductEvent';

    constructor() {
        super();
        this.add();
    }

    eventFunction(data) {
        let clientId = data.client_id;
        let productId = data.productId;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        if (productId) {
            // request data
            data.endPoint = application_settings.endPoints.removeFavoriteProduct;
            data.method = 'POST';
            data.canUsePublicAuth = false;
            data.data = {
                product_id: data.productId,
                location_id: data?.locationId,
            };
            // send request
            this.sendRequest(data, function (response) {
              if (response) {
                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
              }
            });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "productId is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default RemoveFavoriteProduct;